export default "__VITE_ASSET__qbenu9kQ__"